import { render, staticRenderFns } from "./MessageCarousel.vue?vue&type=template&id=9033af5c&"
import script from "./MessageCarousel.vue?vue&type=script&lang=js&"
export * from "./MessageCarousel.vue?vue&type=script&lang=js&"
import style0 from "./MessageCarousel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports